import { forwardRef } from "react";
import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";

import {
  type TCollapsibleContentElement,
  type TCollapsibleContentProps,
} from "@/ui/components/data-display/Collapsible/Collapsible.config";
import { TextBody } from "@/ui/components/typography/TextBody";
import { cn } from "@/ui/lib/utils";

export const CollapsibleContent = forwardRef<TCollapsibleContentElement, TCollapsibleContentProps>(
  (
    {
      children,
      className,
      ...props
    },
    ref,
  ) => (
    <CollapsiblePrimitive.Content
      data-component="CollapsibleContent"
      ref={ref}
      className={cn(
        "overflow-hidden px-4 pt-2 pb-4 gap-2",
        className,
      )}
      {...props}
    >
      <TextBody
        tag="div"
        size={2}
        isResponsive={false}
      >
        { children }
      </TextBody>
    </CollapsiblePrimitive.Content>
  ),
);

CollapsibleContent.displayName = CollapsiblePrimitive.Content.displayName;
